import { PackageRegistrationImpl } from "features/packageRegistration/data/PackageRegistrationImpl";
import { IPackageRegistrationRepository } from "features/packageRegistration/domain/repositories/IPackageRegistrationRepository";
import { PackageRegistrationUseCase } from "features/packageRegistration/domain/useCases/PackageRegistrationUseCase";
import { PackageRegistrationViewModel } from "features/packageRegistration/presentation/viewModel/PackageRegistrationViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class PackageRegistrationInjection extends InjectionModule {
  private static readonly packageRegistrationRepositoryToken = Symbol(
    "IPackageRegistrationRepository",
  );
  private static readonly packageRegistrationViewModelToken = Symbol(
    "PackageRegistrationViewModel",
  );
  private static readonly packageRegistrationUseCaseToken = Symbol(
    "PackageRegistrationUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.packageRegistrationRepositoryToken,
      useClass: PackageRegistrationImpl,
    },
    {
      scope: "otherRepo",
      token: this.packageRegistrationUseCaseToken,
      useClass: PackageRegistrationUseCase,
    },
    {
      scope: "viewModel",
      token: this.packageRegistrationViewModelToken,
      useClass: PackageRegistrationViewModel,
    },
  ];

  static getPackageRegistrationRepo(): IPackageRegistrationRepository {
    return this.resolve(this.packageRegistrationRepositoryToken);
  }

  static getPackageRegistrationUseCase(): PackageRegistrationUseCase {
    return this.resolve(this.packageRegistrationUseCaseToken);
  }
}
